export default {
    "payment": "Платеж",
    "withdrawal": "Вывод",
    "defrosting": "Разморозка",
    "addition": "Пополнение",
};